export const calcDeliveryFee = (zipCode = "", restaurant = {}) => {
  if(!zipCode) {
    if(restaurant.shippingPrices.defaultPrice) return restaurant.shippingPrices.defaultPrice;
  }
  if(restaurant.shippingPrices){
    // If there is a shipping price for that region
    const zonePrice = restaurant.shippingPrices.zonePrices.find(zone => zone.zipCode === zipCode);
    if(zonePrice) return zonePrice.price;

    // If there is no a zone price then return defaultPrice or 0
    if(restaurant.shippingPrices.defaultPrice) return restaurant.shippingPrices.defaultPrice;
  }

  return 0;
}